import React from "react";
import {
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  Text,
  Image,
  Dimensions,
} from "react-native";
// import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import MaterialIcons from "react-native-vector-icons/dist/MaterialIcons";
import colors from "../config/colors";
import { normalize } from "../util/normalize";
import iconFont from "react-native-vector-icons/Fonts/MaterialIcons.ttf";
const iconFontStyles = `@font-face {
  src: url(${iconFont});
  font-family: MaterialIcons;
}`;
// Create stylesheet
const style = document.createElement("style");
style.type = "text/css";
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

// Inject stylesheet
document.head.appendChild(style);

function CommonFooter({ navigation }) {
  const onContactPress = () => {
    navigation.navigate("Info", "https://bluecardvisa.com/contact/");
  };

  const onJobsPress = () => {
    navigation.navigate("Info", "https://recruitmentify.com/");
  };

  const onFAQPress = () => {
    navigation.navigate("Info", "https://bluecardvisa.com/faqs/");
  };

  return (
    <View style={styles.container}>
      <TouchableWithoutFeedback onPress={onFAQPress}>
        <View style={styles.button}>
          <Image source={require("../assets/info.png")} style={styles.icon} />
          <Text style={styles.text}>FAQs</Text>
        </View>
      </TouchableWithoutFeedback>

      <TouchableWithoutFeedback onPress={onJobsPress}>
        <View style={[styles.button, { backgroundColor: colors.red }]}>
          <Image source={require("../assets/plus.png")} style={styles.icon} />
          <Text style={styles.text}>Jobs</Text>
        </View>
      </TouchableWithoutFeedback>

      <TouchableWithoutFeedback onPress={onContactPress}>
        <View
          style={[
            styles.button,
            { width: "40%", backgroundColor: colors.dark },
          ]}
        >
          <MaterialIcons
            name="contact-phone"
            size={30}
            color="white"
            style={styles.icon}
          />
          <Text style={styles.text}>Contact</Text>
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: 1 * Dimensions.get("window").width,
    flexDirection: "row",
  },
  button: {
    backgroundColor: colors.secondary,
    height: 60,
    justifyContent: "center",
    width: "30%",
    borderRadius: 0,
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    textAlign: "center",
    textAlignVertical: "center",
    color: "white",
    fontSize: normalize(19),
    fontWeight: "400",
  },
  icon: {
    marginRight: 5,
    width: 30,
    height: 30,
  },
});

export default CommonFooter;
